document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collections-showcase').forEach((section) => {
    const track = section.querySelector('[data-csw-track]');
    const dotsWrap = section.querySelector('[data-csw-dots]');
    if (!track || !dotsWrap) return;

    const items = Array.from(track.children);
    if (items.length <= 1) return;

    dotsWrap.innerHTML = items.map(() => '<span></span>').join('');
    const dots = Array.from(dotsWrap.children);
    dots[0].classList.add('is-active');

    const setActive = () => {
      const trackRect = track.getBoundingClientRect();
      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const distance = Math.abs(itemRect.left - trackRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === closestIndex);
      });
    };

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setActive();
          ticking = false;
        });
        ticking = true;
      }
    });
  });
});
